module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"address":"A","email":"E"},"en":{"address":"A","email":"E"},"it":{"address":"A","email":"E"},"lt":{"address":"A","email":"E"},"pl":{"address":"A","email":"E"}}')
  delete Component.options._Ctor
}
